import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModelFactory } from './factories/model-factory.service';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export abstract class EnrichResource<T extends {id?: number}> {
  protected abstract resource: string;

  constructor(
    protected httpClient: HttpClient,
    protected modelFactory: ModelFactory<T>,
  ) {}

  public findAll(): Observable<T[]> {
    let url: string = this.resourceUrl();
    return this.httpClient.get(url).map(this.handleResponse.bind(this));
  }

  public get(id: number): Observable<T> {
    let url: string = `${this.resourceUrl()}/${id}`;
    return this.httpClient.get(url).map(this.handleResponse.bind(this));
  }

  public save(model: T): Observable<T> {
    const url: string = `${this.resourceUrl()}/${model.id}`;
    const resource = this.modelFactory.toResource(model);
    return this.httpClient.post(url, resource) as Observable<T>;
  }

  protected resourceUrl(): string {
    return `${environment.baseUrl}/api/${this.resource}`;
  }

  protected resourceUrlv2(): string {
    return `${environment.baseUrlv2}/api/v2/${this.resource}`;
  }

  private handleResponse(response: Response) {
    return this.modelFactory.toModel(response);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/resource.service.ts